import React from "react";
import { useParams } from "react-router-dom";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import APIService from "../../Service/APIService";
import CustomHeader from "../CustomHeader/CustomHeader";
import useDateFilteredData from "../Utils/CustomDateHook";
import DateRangeFilter from "../Utils/DateRangeFilter";
import TableLink from "../../common/table/table-link/index.js";
import EditProductLog from "./EditProductLog";
import TableOptionsCell from "../../common/table/table-options-cell";
import Table from "../../common/table";
import { Modal, message } from "antd";
import dayjs from "dayjs";
import Tags from "../../common/tags/index.js";

const AccountProductLog = ({ readOnly = false, searchValue = "" }) => {
  const params = useParams();
  const [productLogData, setProductLogData] = React.useState([]);
  const [allProductLogData, setAllProductLogData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [orderData, setOrderData] = React.useState(null);
  const [showEditOrderModal, setShowEditOrderModal] = React.useState(false);
  const getData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getaccountproductlog?accountID=${params.id}`
    );
    console.log("Product Log Response: ", response);
    return response?.data?.data;
  };

  const handleEditProductDetails = (row) => {
    if (readOnly) return;
    setOrderData(row);
    setShowEditOrderModal(true);
  };

  const handleDownloadAccountProductLog = async (record) => {

    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(
      record.TissueTrackingFileBlobName
    );

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const tableHeadersProductLog = [
    {
      headerName: "Invoice Number",
      field: "InvoiceNumber",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.InvoiceNumber}
          path={`/InvoiceHome/${params.data.InvoiceID}`}
        />
      ),
    },
    {
      headerName: "TissueID",
      field: "TissueID",
      filter: true,
      // cellRenderer: (params) => (
      //   <TableLink
      //     value={params.data.TissueID}
      //     path={`/InvoiceHome/${params.data.InvoiceID}`}
      //   />
      // ),
    },
    {
      headerName: "Status",
      field: "",
      filter: true,
      cellRenderer: (params) => {
        return (
          <>
            {params?.data.ReturnStarted && !params?.data.ReturnCompleted && (
              <Tags
                textColor="failureColorDark"
                tagBackground="failureColorLight"
                tagText="Return In Progress"
              />
            )}
            {(params?.data?.ReturnCompleted || params?.data.IsReturned) && (
              <Tags
                textColor="failureColorDark"
                tagBackground="failureColorLight"
                tagText="Returned"
              />
            )}
          </>
        );
      },
    },
    {
      headerName: "Product Code",
      field: "ProductCode",
      filter: true,
    },
    {
      headerName: "Patient",
      field: "Patient",
      filter: true,
    },
    {
      headerName: "ApplicationDate",
      field: "ApplicationDate",
      filter: true,
    },
    {
      headerName: "Application #",
      field: "ApplicationNumber",
      filter: true,
    },
    {
      headerName: "Claim #",
      field: "ClaimNumber",
      filter: true,
    },
    {
      headerName: "Cost",
      field: "Cost",
      filter: true,
      cellRenderer: (params) => <div>${params.data.Cost}</div>,
    },
    {
      headerName: "User Actions",
      field: "",
      cellRenderer: (params) =>
        params.data?.TissueTrackingFileBlobName ? (
          <TableOptionsCell
            optionTwo={readOnly ? undefined : "Edit"}
            optionTwoType={readOnly ? undefined : "primary"}
            optionThree="Download"
            optionThreeType="success"
            optionTwoClickFn={readOnly ? undefined : () => handleEditProductDetails(params.data)}
            optionThreeClickFn={() =>
              handleDownloadAccountProductLog(params.data)
            }
          />
        ) : (
          readOnly ? null : <TableOptionsCell
            optionTwo="Edit"
            optionTwoType="primary"
            optionTwoClickFn={() => handleEditProductDetails(params.data)}
          />
        ),
    },
  ];

  React.useEffect(() => {
    console.log("Account Product Log");
    getData()
      .then((data) => {
        console.log("Product Log Data: ", data);
        let tempData = data;
        tempData.map((ele) => {
          ele["ApplicationDate"] =
            ele["ApplicationDate"] === null
              ? null
              : dayjs(ele["ApplicationDate"]).format("MM-DD-YYYY");
          ele["ApplicationDateField"] = dayjs(ele["ApplicationDate"]);
          ele["Price"] = `$${parseFloat(ele["Price"]).toLocaleString("en-US", {
            maximumFractionDigits: 2,
          })}`;
        });
        setProductLogData(data);
        setAllProductLogData(data);
      })
      .then(() => {
        setLoading(false);
      });
  }, []);

  const { fetchData } = useDateFilteredData("getpaymentsapplied", 0, 10, null, {
    fetchOnMount: false,
    transformResponse: (data) => {
      let tempData = data;
      tempData.map((ele) => {
        ele["ApplicationDate"] =
          ele["ApplicationDate"] === null
            ? null
            : dayjs(ele["ApplicationDate"]).format("MM-DD-YYYY");
        ele["ApplicationDateField"] = dayjs(ele["ApplicationDate"]);
        ele["Price"] = `$${parseFloat(ele["Price"]).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        })}`;
      });
      setProductLogData(data);
      setAllProductLogData(data);
    },
  });

  const handleDateFilterChange = async (dateRange) => {
    await fetchData(dateRange);
  };

  React.useEffect(() => {
    const value = searchValue?.trim() ?? "";
    if (!value) {
      setProductLogData(allProductLogData);
      return;
    }
    const lower = value.toLowerCase();
    setProductLogData(
      allProductLogData.filter(
        (item) =>
          item?.InvoiceNumber?.toLowerCase()?.includes(lower) ||
          item?.TissueID?.toLowerCase()?.includes(lower) ||
          item?.ProductCode?.toLowerCase()?.includes(lower) ||
          item?.Patient?.toLowerCase()?.includes(lower)
      )
    );
  }, [searchValue, allProductLogData]);

  console.log(productLogData, "productLogData >>>> 1");

  return (
    <div>
      {(loading || (productLogData && productLogData.length > 0)) && (
        <Table
          rowData={loading ? [] : productLogData}
          columnDefs={tableHeadersProductLog}
          screen="AccountProductLog"
          loading={loading}
        />
      )}
      {showEditOrderModal && !readOnly && (
        <Modal
          title="Update Product Details"
          width={900}
          open={showEditOrderModal}
          onCancel={() => setShowEditOrderModal(false)}
          footer={[]}
        >
          <EditProductLog orderData={orderData} />
        </Modal>
      )}
    </div>
  );
};

export default AccountProductLog;
